import { useContext, useEffect } from "react";
import useFirestore from "../basic/useFirestore";
import { collection, getDocs, query, where } from "firebase/firestore";
import { FirebaseContext } from "../../providers/FirebaseProvider/FirebaseProvider";

function useUserAppData(userId) {
  const { firestoreDb } = useContext(FirebaseContext);

  const firestoreQueryMethod = async () => {
    const usersCollection = collection(firestoreDb, "users"); // Collezione "users"
    const q = query(usersCollection, where("user_id", "==", userId));
    try {
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // Supponiamo che ci sia solo un documento corrispondente
        const userDoc = querySnapshot.docs[0];
        console.log("Documento trovato:", userDoc.data());

        return userDoc; // Ritorna i dati dell'utente
      } else {
        console.log("Nessun documento trovato con user_id:", userId);
        return null;
      }
    } catch (error) {
      console.error("Errore nella query:", error);
    }
  };
  const parsingFuntion = (data) => {
    console.log("Parsing data:", data);
    return {
      id: data.id,
      ...data.data(),
    };
  };

  const { data, error, isLoading, refreshData } = useFirestore(
    firestoreQueryMethod,
    parsingFuntion,
    !userId,
  );

  useEffect(() => {
    if (userId) {
      refreshData();
    }
  }, [userId]);

  return {
    data,
    error,
    isLoading,
    refreshData,
  };
}

export default useUserAppData;
